module.exports = __webpack_public_path__ + "img/user-minus.7fad484d.svg";